/*********************************************************
 *                  Admin cleaning Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin").controller(
	"CleaningCtrl",
	["$http", "$scope", "clients", "ExploitationService", "AdminClientsService", "OpenImportsService", "OpenExportsService", "SecurityService" , "ENV", "toastr", "Utils", "$uibModal", "$location",
			($http, $scope, clients, ExploitationService, AdminClientsService, OpenImportsService, OpenExportsService, SecurityService, ENV, toastr, Utils, $uibModal,$location) => {
				if (!SecurityService.hasRight('dbCleaning')) {
					$location.path("/");
				}
				$scope.data = {
					clients: clients.data
				};
				AdminClientsService.getCurrentClient().then((client)=>{
					$scope.selectedClient = client.name;
				}).catch(()=>{
					toastr.error("Erreur dans la récupération de l'organisation");
				});

				let deleteStopPlacesByOrganisationModal;
				let deleteParkingsModal;
				let deletePOIsModal;
				let deleteDataspaceByOrganisationModal;

				$scope.hasRight = (rightName) => SecurityService.hasRight(rightName);

				$scope.openDeleteStopPlacesByOrganisation = () => {
					if($scope.selectedClient == "TECHNIQUE") {
						toastr.error("Aucune organisation n'a été séléctionné");
					}else {
						deleteStopPlacesByOrganisationModal = Utils.openModal($uibModal, "deleteStopPlacesByOrganisationModal.html", $scope);
					}
				}
				$scope.openDeleteParkings = () => {
					deleteParkingsModal = Utils.openModal($uibModal, "deleteParkingsModal.html", $scope);
				}
				$scope.openDeletePOIs = () => {
					deletePOIsModal = Utils.openModal($uibModal, "deletePOIsModal.html", $scope);
				}
				$scope.openDeleteDataspaceByOrganisation = () => {
					if($scope.selectedClient == "TECHNIQUE") {
						toastr.error("Aucune organisation n'a été séléctionné");
					}else {
						deleteDataspaceByOrganisationModal = Utils.openModal($uibModal, "deleteDataspaceByOrganisationModal.html", $scope);
					}
				}
				$scope.deleteStopPlacesByOrganisation = () => {
					$http.post(ENV.TIAMAT_BASE_URL + 'graphql', {
						"query": "mutation mutateDeleteStopPlaceByOrganisation($organisationName: String!) {deleteStopPlaceByOrganisation(organisationName: $organisationName)}",
						"variables": {
							"organisationName": $scope.selectedClient
						}
					}).then((response)=>{
						deleteStopPlacesByOrganisationModal.close();
						toastr.success("Les points d'arrêts ont bien été suprimés");
					}).catch((error)=>{
						toastr.error(error.data.message, "Erreur dans la supression des points d'arrêts");
					});
				}
				$scope.deleteParkings = () => {
					AdminClientsService.getReferentialIdAndUser().then((referential) => {
						$http.post(ENV.TIAMAT_BASE_URL + 'deleteall/parkings', {
							headers: {
								'Content-Type': 'application/json',
								Accept: 'application/json',
								'RutebankenUser': referential.user
							}
						}).then(() => {
							deleteParkingsModal.close()
							toastr.success("Les parkings ont bien été suprimés");
						}).catch((error) => {
							toastr.error(error.data.message, "Erreur dans la supression des parkings");
						});
					});
				}
				$scope.deletePOIs = () => {
					AdminClientsService.getReferentialIdAndUser().then((referential) => {
						$http.post(ENV.TIAMAT_BASE_URL + 'deleteall/poi', {
							headers: {
								'Content-Type': 'application/json',
								Accept: 'application/json',
								'RutebankenUser': referential.user
							}
						}).then(() => {
							deletePOIsModal.close()
							toastr.success("Les points d'intérêts ont bien été suprimés");
						}).catch((error) => {
							toastr.error(error.data.message, "Erreur dans la supression des points d'intérêts");
						});
					});
				}
				async function getProvider(clientCode) {
					const provResp = await $http.get(ENV.PROVIDERS_BASE_URL);
					return provResp.data.find(p => p.name === clientCode || p.chouetteInfo.referential === clientCode);
				}
				$scope.deleteDataspaceByOrganisation = () => {
					const client = $scope.data.clients.find(c => c.name == $scope.selectedClient);

					getProvider(client.code).then((referential) => {
						$http.post(ENV.TIMETABLE_ADMIN_BASE_URL + referential.id + '/clean', "", {
								headers: {
									"PROVIDER": referential.id,
									"Content-Type": "application/json",
									"RutebankenUser": referential.user
								}
							}
						).then(() => {
							deleteDataspaceByOrganisationModal.close()
							toastr.success("L'espace de données a bien été supprimé");
						}).catch((error) => {
							toastr.error(error.data.message, "Erreur dans la supression de l'éspace de données");
						});
					}).catch(() => {
						toastr.error("Erreur dans la récupération de l'organisation");
					});

				}
			}
		]
)